 
import React, { useState, useEffect } from "react";
import runBabyRun from "../../Assets/Images/run.png";
import movie1 from "../../Assets/Images/OP2.png";
import movie2 from "../../Assets/Images/OP3.png";
import movie3 from "../../Assets/Images/OP4.png";
import "../../Assets/Css/OurProductionSection.css";
import { FaChevronRight } from "react-icons/fa";
import OPTrailerPopup from "../../Components/OPTrailerPopup/OPTrailerPopup";
import TrailerImage1 from "../../Assets/Images/TrailerImage1.png"
import TrailerImage2 from "../../Assets/Images/TrailerImage2.png"
import TrailerImage3 from "../../Assets/Images/TrailerImage3.png"
import TrailerImage4 from "../../Assets/Images/TrailerImage4.png"
 
 
const OurProductionSection = () => {
  const [selectedTrailer, setSelectedTrailer] = useState(null);
 
  const trailers = [
    {
      poster: runBabyRun,
      title: "Run Baby Run",
      subtitle: "2023",
      description: "",
      background: TrailerImage2,
      button: ["jio"],
      link: "https://www.youtube.com/watch?v=cdokNqlGZrs",
      ottLink: "https://www.hotstar.com/in/movies/run-baby-run/1260132747", // Add OTT link here
    },
    {
      poster: movie1,
      title: "Lubber Pandhu",
      subtitle: "2024",
      description: "",
      background: TrailerImage1,
      button: ["jio"],
      link: "https://www.youtube.com/watch?v=oP88LHBukW8",
      ottLink: "https://www.hotstar.com/in/movies/lubber-pandhu/1271335839", // Add OTT link here
    },
    {
      poster: movie2,
      title: "Dev",
      subtitle: "2019",
      description: "",
      background: TrailerImage4,
      button: ["prime"],
      link: "https://www.youtube.com/watch?v=AB2LXzNvUNo",
      ottLink: "https://www.primevideo.com/region/eu/detail/0GXH5JML8J3Q0LIJ3ZBPVX3DN1/ref=atv_sr_fle_c_Tn74RA_1_1_1?sr=1-1&pageTypeIdSource=ASIN&pageTypeId=B0CY2D5QMJ&qid=1741755783543", // Add OTT link here
    },
    {
      poster: movie3,
      title: "Sardar",
      subtitle: "2023",
      description: "",
      background: TrailerImage3,
      button: ["aha"],
      link: "https://www.youtube.com/watch?v=8OQzz_i3KFE",
      ottLink: "https://www.aha.video/movie/sardar-tamil", // Add OTT link here
    },
  ];
 
  // Disable scrolling when the popup is open
  useEffect(() => {
    if (selectedTrailer) {
      document.body.classList.add("popup-open");
    } else {
      document.body.classList.remove("popup-open");
    }
 
    // Cleanup function
    return () => {
      document.body.classList.remove("popup-open");
    };
  }, [selectedTrailer]);
 
  const handleCardClick = (trailer) => {
    setSelectedTrailer(trailer);
  };
 
  const closePopup = () => {
    setSelectedTrailer(null);
  };
 
  return (
    <div className="prcontainer" id="productions">
      <h2 className="prtitle">Our Productions</h2>
      <div className="prgrid-container">
        {/* Large Poster */}
        <div className="prlarge-poster" onClick={() => handleCardClick(trailers[0])}>
          <img
            src={runBabyRun}
            alt="Featured Movie"
            className="primage"
          />
        </div>
        {/* Small Posters Grid */}
        <div className="prsmall-posters">
          <div onClick={() => handleCardClick(trailers[1])}>
            <img
              src={movie1}
              alt="Movie 1"
              className="primage"
            />
          </div>
          <div className="prrelative" onClick={() => handleCardClick(trailers[2])}>
            <img
              src={movie2}
              alt="Movie 2"
              className="primage"
            />
            <button className="prnavplay-button">
              <FaChevronRight className="icon" />
            </button>
          </div>
          <div onClick={() => handleCardClick(trailers[3])}>
            <img
              src={movie3}
              alt="Movie 3"
              className="prfull-width-image"
            />
          </div>
        </div>
      </div>
 
      {/* Conditional Rendering of the Popup */}
      {selectedTrailer && (
        <OPTrailerPopup trailer={selectedTrailer} onClose={closePopup} />
      )}
    </div>
  );
};
 
export default OurProductionSection;